const modalStyle = {
    overlay : {
        backgroundColor   : 'rgba(0,0,0,.5)',
        zIndex            : 51,
    },
    content : {
        top              : '50%',
        left             : '50%',
        right            : 'auto',
        bottom           : 'auto',
        marginRight      : '-50%',
        transform        : 'translate(-50%, -50%)',
        border           : 'none',
        background       : '#fff',
        borderRadius     : '0',
        width            : '90%',
        maxWidth         : '600px',
    }
}

const fullModalStyle = {
    overlay: {...modalStyle.overlay},
    content: {
        top              : 0,
        left             : 0,
        right            : 0,
        bottom           : 0,
        border           : 'none',
        background       : '#fff',
        borderRadius     : '0',
    }
}

const largeModalStyle = {
    overlay: {...modalStyle.overlay},
    content: {
        top              : '50%',
        left             : '50%',
        right            : 'auto',
        bottom           : 'auto',
        marginRight      : '-50%',
        transform        : 'translate(-50%, -50%)',
        border           : 'none',
        background       : '#fff',
        borderRadius     : '0',
        width            : '90%',
        maxWidth         : '1700px',
        maxHeight        : 'calc(100vh - 80px)',
        overflowY        : 'auto',
    },
}

const mediumModalStyle = {
    overlay: {...modalStyle.overlay},
    content: {
        top              : '50%',
        left             : '50%',
        right            : 'auto',
        bottom           : 'auto',
        marginRight      : '-50%',
        transform        : 'translate(-50%, -50%)',
        border           : 'none',
        background       : '#fff',
        borderRadius     : '0',
        width            : '90%',
        maxWidth         : '1300px',
        maxHeight        : 'calc(100vh - 80px)',
        overflowY        : 'auto',
    },
}

const mediumModalStyleMedia = {
    overlay: {...modalStyle.overlay},
    content: {
        top              : '62%',
        left             : '50%',
        right            : 'auto',
        bottom           : 'auto',
        marginRight      : '-50%',
        transform        : 'translate(-50%, -50%)',
        border           : 'none',
        background       : '#fff',
        borderRadius     : '0',
        width            : '90%',
        maxWidth         : '1300px',
        maxHeight        : 'calc(100vh - 80px)',
        overflowY        : 'auto',
    },
}

const mediumModalStyleMedia80top = {
    overlay: {...modalStyle.overlay},
    content: {
        top              : '80%',
        left             : '50%',
        right            : 'auto',
        bottom           : 'auto',
        marginRight      : '-50%',
        transform        : 'translate(-50%, -50%)',
        border           : 'none',
        background       : '#fff',
        borderRadius     : '0',
        width            : '90%',
        maxWidth         : '1300px',
        maxHeight        : 'calc(100vh - 80px)',
        overflowY        : 'auto',
    },
}

const mediumSmModalStyle = {
    overlay: {...modalStyle.overlay},
    content: {
        top              : '50%',
        left             : '50%',
        right            : 'auto',
        bottom           : 'auto',
        marginRight      : '-50%',
        transform        : 'translate(-50%, -50%)',
        border           : 'none',
        background       : '#fff',
        borderRadius     : '0',
        width            : '90%',
        maxWidth         : '800px',
        maxHeight        : 'calc(100vh - 80px)',
        overflowY        : 'auto',
    },
}

const documentTypes = [
    'accidentReports',
    'award',
    'changeOrders',
    'commissioning',
    'constructionProgressReport',
    'contractBidBook',
    'contracts',
    'controlledInspection',
    'correspondence',
    'cpi',
    'dailyReports',
    'delayClaims',
    'designDevelopment',
    'designorConstructionPlan',
    'designProgressReport',
    'designReviews',
    'drainagePlan',
    'fieldDirectives',
    'funding',
    'issuedForBid',
    'memorandumOfBids',
    'monthlyReports',
    'mwbe',
    'noticeToProceed',
    'other',
    'p100FinalDesign',
    'p50FinalDesign',
    'payments',
    'permits',
    'photographs',
    'preSchematicDesign',
    'progressReport',
    'projectAssessment',
    'proposals',
    'qacs',
    'rfIs',
    'schedule',
    'schematicDesign',
    'siteEngineering',
    'specification',
    'strategyBoardConclusions',
    'substantialCompletion',
    'surveyCatFile',
    'sustainabilityLEED',
    'timeExtension'
]

const googleMapsKey = 'AIzaSyAmfApFvvmRwOGnSv_1XIy0Z7UMac5vW5w';

const adjustmentReasons = [
    'Scope Change by Client',
    'Time Extension/Non-Scope Change',
    'Funding Issue/Oversight Agency Review',
    'Approval/Reviews/Special Testing(e.g. HVAC, Sprinklers, Permits, Art Comm.,Parks, etc.)',
    'Supply Issue (Special Materials/Equipment/Fabrication)',
    'Weather Condition',
    'Unforeseen Condition (e.g. Site, Hazmat, etc.)',
    'Design Error(s)/Changes',
    'Project On-Hold by Client',
    'Project On-Hold by DDC',
    'Termination/Default/Reassignment, of Contractor/Sub/Consultant/Supplier',
    'Consultant Delays',
    'Site Inaccessible',
    'Coordination/Combination with other Project(s)',
    'Utility Interference/Delay',
    'Procurement Delay',
    'Acquisition/Easement Issue(s)',
    'Survey Issue(s)',
    'Contractor Performance Issues(s)',
    'Correction to Baseline Schedule',
    'Correction to Projected Schedule',
]

export {
  documentTypes,
  googleMapsKey,
  modalStyle,
  fullModalStyle,
  adjustmentReasons,
  mediumModalStyle,
  mediumModalStyleMedia,
  mediumModalStyleMedia80top,
  largeModalStyle,
  mediumSmModalStyle
};
